<template>
  <div class='visually-hidden' :aria-hidden='ariaHidden' :aria-live='ariaLive' v-bind='$attrs' :style='computedStyle'>
    <slot />
  </div>
</template>
<script>
export default {
  name: 'VisuallyHidden',
  props: {
    style: {
      type: [String, Object, Array],
      default: () => ({}),
    },
    ariaLive: {
      type: String,
      default: 'default'
    },
    ariaHidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedStyle() {
      return [
        this.style,
        {
          position: 'absolute',
          border: 0,
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          // https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
          whiteSpace: 'nowrap',
          wordWrap: 'normal',
        },
      ];
    },
  },
};
</script>
